import {
    LaboratoryOrderCreationParams,
    LaboratoryOrderData,
    LaboratoryOrderListQuery,
    LaboratoryOrderListResponse,
    OrderStatus,
    LaboratoryOrderReferralData,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/order';

export class LaboratoryOrderApi {
    public static async create(order: LaboratoryOrderCreationParams): Promise<void> {
        await axios.post(BASE_URL, { order });
    }

    public static async updateStatus(id: string, status: OrderStatus, additionalServiceIds?: string[]): Promise<void> {
        await axios.put(`${BASE_URL}/${id}/status`, { status, additionalServiceIds });
    }

    public static async updateStatusForce(id: string, status: OrderStatus): Promise<void> {
        await axios.put(`${BASE_URL}/${id}/status/force`, { status });
    }

    public static async getList(params?: LaboratoryOrderListQuery): Promise<LaboratoryOrderData[]> {
        const res = await axios.get(BASE_URL, { params });
        return res.data.orders;
    }

    public static async getListWithCount(params?: LaboratoryOrderListQuery): Promise<LaboratoryOrderListResponse> {
        const res = await axios.get<LaboratoryOrderListResponse>(BASE_URL, { params });
        return res.data;
    }

    public static async getOrderReferrals(id: string): Promise<LaboratoryOrderReferralData[]> {
        const res = await axios.get(`${BASE_URL}/${id}/referrals`);
        return res.data.referrals;
    }
}
